import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPromoCodeErrorIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.49 13h1.01l.5-6h-2l.49 6zM11 15h2v2h-2z",
			style: { fill: "rgb(204, 25, 34)" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 17a8 8 0 1 1 8-8 8 8 0 0 1-8 8z",
			style: { fill: "rgb(204, 25, 34)" }
		})
	]
});
const ForwardRef = forwardRef(SvgPromoCodeErrorIcon);
export default ForwardRef;
